import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../../services/toast/toast.service';
import { Roles } from '../../../enums/roles.enum';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly toastService: ToastService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const expectedRoles: string[] = route.data['roles'];
    const userRoles = this.authService.getUserRoles();
    const normalizedUserRoles = Array.isArray(userRoles) ? userRoles.map((role) => role.toUpperCase().trim()) : [];

    if (userRoles && expectedRoles.some((role) => userRoles.includes(role))) {
      return true;
    }

    if (normalizedUserRoles.includes(Roles.SuperAdmin) || normalizedUserRoles.includes(Roles.Admin)) {
      this.toastService.error('No tienes permisos para acceder a esta página');
      return this.router.createUrlTree(['/admin']);
    } else if (normalizedUserRoles.includes(Roles.Representante) || normalizedUserRoles.includes(Roles.Usuario)) {
      this.toastService.error('No tienes permisos para acceder a esta página');
      return this.router.createUrlTree(['/home']);
    }

    return this.router.createUrlTree(['/dashboard']);
  }
}
